export default __webpack_public_path__ + "static/media/web_development_.59a2b9bb.png";